import React, { useState, useEffect } from 'react';
import { ConfigProvider } from 'antd';
import { CustomLoader } from '@components/UI/CustomLoader/Index.jsx';
import { StyledTable } from '@styles/datatables/datatable-antd.js';
import ptBR from 'antd/es/locale/pt_BR';

const GridRelatorioHistorico = ({ state, setData }) => {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const fetchData = async (currentPage, currentRowsPerPage) => {
    setLoading(true);
    try {
      const response = await GetAllProcessos(currentPage, currentRowsPerPage);
      setData(response.items, response.totalItems);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
  };

  const columns = [
    {
      title: 'NÚMERO',
      dataIndex: 'numSolicitacao',
      key: 'numSolicitacao',
      sorter: (a, b) => a.numSolicitacao - b.numSolicitacao,
      width: '12%',
    },
    {
      title: 'DATA/HORA',
      dataIndex: 'dataHora',
      key: 'dataHora',
      sorter: (a, b) => a.dataHora.localeCompare(b.dataHora),
    },
    {
      title: 'EVENTO',
      dataIndex: 'evento',
      key: 'evento',
      sorter: (a, b) => a.evento.localeCompare(b.evento),
    },
    {
      title: 'AÇÃO',
      dataIndex: 'acao',
      key: 'acao',
      sorter: (a, b) => a.acao.localeCompare(b.acao),
    },
    {
      title: 'UNIDADE/GERÊNCIA',
      dataIndex: 'unidadeGerencia',
      key: 'unidadeGerencia',
      sorter: (a, b) => a.unidadeGerencia.localeCompare(b.unidadeGerencia),
      width: '21%',
    },
    {
      title: 'STATUS',
      dataIndex: 'status',
      key: 'status',
      sorter: (a, b) => a.status.localeCompare(b.status),
      width: '15%',
    },
  ];

  return (
    <div className='px-4'>
      <ConfigProvider locale={ptBR}>
        <StyledTable
          title={() => (
            <div>
              <i className="fa-solid fa-file"></i>
              <span className='p-2 datatable-title'>Consulta - Histórico / Logs de Auditoria</span>
            </div>
          )}
          columns={columns}
          //dataSource={}
          loading={{
            spinning: loading,
            indicator: <CustomLoader />, // Spinner personalizado
          }}
          pagination={{
            current: page,
            pageSize: rowsPerPage,
            total: state.totalRows,
            onChange: handlePageChange,
            showSizeChanger: true,
            onShowSizeChange: handlePageChange,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`, // Exibe o total de registro
          }}
          scroll={{ y: '20rem', x: 'max-content' }}
          locale={{ emptyText: <h2 className='m-3'>Nenhuma consulta disponível para exibição.</h2> }}
        />
      </ConfigProvider>
    </div>
  );
};

export default GridRelatorioHistorico;